const STORAGE_KEY = 'toolbarButtonDisplayMode'

// Global, app-wide (not per-page) UI-density preference for the redesigned toolbar
// buttons -- one admin staff member's choice, remembered in this browser via
// localStorage, same mechanism as the existing column-visibility/sort-direction
// preferences elsewhere in this codebase. Default is unchanged from before this
// redesign (labels shown) until someone opts into icon-only.
export default {
  data() {
    return {
      toolbarButtonDisplayMode: localStorage.getItem(STORAGE_KEY) || 'label'
    }
  },

  computed: {
    showButtonLabels() {
      return this.toolbarButtonDisplayMode !== 'icon'
    }
  },

  methods: {
    $_toggle_toolbar_button_display() {
      this.toolbarButtonDisplayMode = this.toolbarButtonDisplayMode === 'icon' ? 'label' : 'icon'
      localStorage.setItem(STORAGE_KEY, this.toolbarButtonDisplayMode)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/toolbarButtonDisplay.js